export default {
  'status': 'Translation validated by country',
  'meta': {
    'lang': 'Français'
  },
  'title': 'RAPPEL PRODUIT QUICKDRAWS SIMOND ALPINISM / VERTIKA',
  'homepage': {
    'notice': 'Rappel Produit. Information importante concernant votre sécurité et votre équipement.',
    'purchaseWindow': 'Vous avez acheté une dégaine d\'escalade ALPINISM et/ou VERTIKA entre le 01/01/2022 et le 23/07/2026.',
    'skus': 'Dégaine Alpinism 11 cm (4051175 / 8589547)\nDégaine Alpinism 17 cm (4051176 / 8589548\nPack X5 Dégaine Alpinism (4171656 / 8608405)\nDégaine Vertika 11 cm (5499689 / 8935765)\nDégaine vertika 17 cm (5500194 / 8935909)',
    'responsibility': 'Concevoir des équipements de protection individuelle implique une responsabilité absolue envers celles et ceux qui utilisent nos produits. C’est à ce titre que nous vous informons d’une mesure de rappel concernant la dégaine équipée du mousqueton Rocky Fil.',
    'defect': 'Nous avons identifié un défaut sur le rivetage du doigt fil de certains mousquetons. Ce défaut d\'assemblage peut entraîner la rupture du doigt fil et engendrer un risque de casse du mousqueton en cas de chute.',
    'stopUsing': 'Par mesure de précaution, nous vous demandons d\'interrompre immédiatement l\'utilisation de votre produit et de suivre la procédure ci-dessous.'
  },
  'procedure': {
    'stopUsing': 'Nous vous demandons donc de cesser immédiatement l\'utilisation de cet équipement et de vérifier si votre produit est concerné par ce défaut à l\'aide des indications de contrôle ci-dessous.',
    'title': 'Vérifiez vos produits :',
    'intro': 'Vérifiez que les 2 côtés du doigt fil restent bien fixés sur le mousqueton :',
    'step1': 'Prenez le mousqueton d’un côté, mettez votre pouce entre les deux fils (pouce au plus près du rivetage). Appuyez fortement vers le bas par rapport au mousqueton.',
    'step2': 'Retournez le mousqueton refaites le même geste de l\'autre côté du doigt fil.'
  },
  'outcome': {
    'nok': {
      'body': 'Après contrôle, le fil sort de son logement : Merci de ne plus utiliser votre produit et de vous rendre dans le magasin DECATHLON le plus proche. Sur place, nos équipes prendront directement en charge votre produit défectueux et procéderont immédiatement au remboursement intégral de ces produits faisant l’objet du rappel.',
      'support': 'Si vous êtes dans une situation particulière, notre service client reste à votre entière disposition pour vous trouver une solution sur-mesure et vous accompagner pas à pas : 0800 710 770 du Lundi au Samedi de 09h00 à 19h00 .'
    },
    'ok': {
      'body': 'Après contrôle, le fil ne sort pas de son logement : Votre produit n\'est pas concerné par ce défaut, vous pouvez continuer à l\'utiliser en toute sérénité.'
    }
  },
  'buttons': {
    'ok': 'Mon produit est OK',
    'nok': 'Mon produit est NOK'
  }
} as const
